import { useCallback } from "react";
import { useCurrentAccountId } from "@zapier/identity";
import emitUserInteractionEvent, {
  UserInteractionName,
} from "./emitUserInteractionEvent";

export type ChatbotDeleteModalAction = "confirm" | "cancel";

export function useEmitChatbotDeleteModalEvent() {
  const accountId = useCurrentAccountId();

  const emit = useCallback(
    (optionSelected: ChatbotDeleteModalAction) => {
      emitUserInteractionEvent({
        accountId,
        interactionName: UserInteractionName.ChatbotDeleteModal,
        optionSelected,
      });
    },
    [accountId],
  );

  return { emit };
}
